import React from 'react';
import DatabaseExplorer from '../components/metadata/DatabaseExplorer';

const SchemaExplorer = () => {
  return (
    <div>
      <div className="items-center justify-between mb-6 ">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Database Explorer</h1>
       
        <div className="text-sm text-gray-500 pr-20">
          Explore schemas, tables, and generate queries
        </div>
      </div>
      
      <DatabaseExplorer />
    </div>
  );
};

export default SchemaExplorer;